"use strict";

define('model/attribute.value',['./base', './attribute', 'datakit/util/url'], function (BaseModel, AttributeModel, url) {
  var AttributeValue = BaseModel.extend({
    urlRoot: '/rs/api/attribute',
    virtual: {
      attributeName: BaseModel.createKeyPathVirtual('attribute.name')
    },
    url: function url() {
      var attribute = this.get('attribute'),
        name = attribute.get('name');
      if (name == 'Alternate') {
        return this._alternateUrl();
      } else if (name == 'Alternate For') {
        return this._alternateForUrl();
      }
      return this.urlRoot;
    },
    childModels: {
      attribute: 'Attribute',
      person: 'Person',
      group: 'Board'
    },
    _alternateUrl: function _alternateUrl() {
      return url.template('/rs/api/alternate/:boardMemberId/:alternateId/:groupId', {
        boardMemberId: this.get('person').id,
        alternateId: _.isObject(this.get('value')) ? this.get('value').id : this.get('value'),
        groupId: this.get('group').id
      });
    },
    _alternateForUrl: function _alternateForUrl() {
      return url.template('/rs/api/alternate/:boardMemberId/:alternateId/:groupId', {
        boardMemberId: _.isObject(this.get('value')) ? this.get('value').id : this.get('value'),
        alternateId: this.get('person').id,
        groupId: this.get('group').id
      });
    },
    _readUrl: function _readUrl() {
      return url.template('/rs/api/boardMember/attribute/:personId/:groupId/:attributeId', {
        personId: this.get('person').id,
        groupId: this.get('group').id,
        attributeId: this.get('attribute').id
      });
    },
    serializeChildModel: function serializeChildModel(model, options) {
      var json = BaseModel.prototype.serializeChildModel.apply(this, arguments);
      if (model instanceof AttributeModel) {
        json.name = model.get('name');
      }
      return json;
    },
    sync: function sync(method, model, options) {
      if (method == 'update') {
        options.type = 'POST';
      } else if (method == 'read') {
        options.url = this._readUrl();
      }
      var success = options.success,
        name = this.get('attribute').get('name');
      options.success = function (resp) {
        if (name == 'Alternate For') {
          resp = _.omit(resp, 'data');
          resp.data = {};
        }
        if (success) success(resp);
      };
      return BaseModel.prototype.sync.call(this, method, model, options);
    }
  });
  return AttributeValue;
});

